import React, { FC } from 'react';

import { DedicatedRouteProps } from 'home/view/check-feasibility/comp-generator/common-interface';
import AuthView from './auth-view';

import './index.scss';

interface Props {}

export const CheckFeasibilityAOI: FC<DedicatedRouteProps> = (props) => {
  const { isUnAuthJourney } = props;

  const renderCheckFeasibility = () => {
    if (isUnAuthJourney) {
      return null;
    }

    return <AuthView {...props} />;
  };

  return <div className="check-feasibility-wrapper">{renderCheckFeasibility()}</div>;
};

export default CheckFeasibilityAOI;
